import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import apiService from "../services/apiServices";

export const useCrud = ({ endpoint, queryKey, customApi }) => {
  const api = customApi ? apiService(customApi) : apiService("api/");
  const queryClient = useQueryClient();

  let orgId = null;
  try {
    const auth = JSON.parse(localStorage.getItem("auth"));
    orgId = auth?.org || null;
    // if (!orgId) {
    //   console.warn(" Org ID not found in localStorage");
    // }
  } catch (error) {
    console.error(" Error parsing auth from localStorage:", error);
  }

  const useGetAll = () =>
    useQuery({
      queryKey: [queryKey],
      queryFn: async () => {
        // if (!orgId) throw new Error("Missing org ID");
        // const response = await api.get(`${endpoint}?org=${orgId}`);
         const response = await api.get(`${endpoint}`);
        console.log(response);
        /* return response.filter((item) => !item.is_archive); */
        return response;
      },
      // enabled: !!orgId && typeof window !== "undefined",
      onError: (error) => {
        console.error(` Error fetching ${queryKey}:`, error);
      },
    });

  // const useGetFiltered = (queryParam) =>
  //   useQuery({
  //     // queryKey: [queryKey, orgId],
  //     queryKey: [queryKey],
  //     queryFn: async () => {
  //       // if (!orgId) throw new Error("Missing org ID");
  //       const response = await api.get(
  //         // `${endpoint}?org=${orgId}&${queryParam}`
  //         `${endpoint}?${queryParam}`
  //       );
  //       /* return response.filter((item) => !item.is_archive); */
  //       return response;
  //     },
  //     // enabled: !!orgId && typeof window !== "undefined",
  //     onError: (error) => {
  //       console.error(` Error fetching ${queryKey}:`, error);
  //     },
  //   });
const useGetFiltered = (queryParam = "") =>
  useQuery({
    queryKey: [queryKey, queryParam],
    queryFn: async () => {
      const response = await api.get(
        queryParam ? `${endpoint}?${queryParam}` : endpoint
      );
      return response;
    },
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    onError: (error) => {
      console.error(`Error fetching ${queryKey}:`, error);
    },
  });

  const useGetFilteredByDateRange = (startDate, endDate) =>
    useQuery({
      queryKey: [queryKey, orgId],
      queryFn: async () => {
        if (!orgId) throw new Error("Missing org ID");
        const response = await api.get(
          `${endpoint}?org=${orgId}&start_date=${startDate}&end_date=${endDate}`
        );
        /* return response.filter((item) => !item.is_archive); */
        return response;
      },
      enabled: !!orgId && !!startDate && !!endDate,
      onError: (error) => {
        console.error(` Error fetching ${queryKey}:`, error);
      },
    });

  const useGetById = (idKey, idValue) =>
    useQuery({
      queryKey: [queryKey, orgId, idValue],
      queryFn: async () => {
        if (!orgId) throw new Error("Missing org ID");
        const response = await api.get(
          `${endpoint}?org=${orgId}&${idKey}=${idValue}`
        );
        return response.filter((item) => !item.is_archive);
      },
      enabled: !!orgId && !!idValue && typeof window !== "undefined",
      onError: (error) => {
        console.error(` Error fetching ${queryKey} by ID:`, error);
      },
    });

  const useCreate = () =>
    useMutation({
      mutationFn: async (data) => {
        if (!orgId) throw new Error("Missing org ID");

        const isFormData = data instanceof FormData;

        return api.post(`${endpoint}?org=${orgId}`, data, {
          headers: isFormData
            ? {} // let browser set multipart boundary
            : { "Content-Type": "application/json" },
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey, orgId] });
      },
      onError: (error) => {
        console.error("UPLOAD ERROR:", error.response?.data);
      },
    });

  const useUpdate = () =>
    useMutation({
      mutationFn: async ({ id, data }) => {
        if (!orgId) throw new Error("Missing org ID");
        const response = await api.patch(
          `${endpoint}${id}/?org=${orgId}`,
          data
        );
        return response;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey, orgId] });
      },
      onError: (error) => {
        console.error(` Error updating ${queryKey}:`, error);
      },
    });

  const useArchive = () =>
    useMutation({
      mutationFn: async (id) => {
        if (!orgId) throw new Error("Missing org ID");
        const response = await api.patch(`${endpoint}${id}/?org=${orgId}`, {
          is_archive: true,
        });
        return response;
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey, orgId] });
      },
      onError: (error) => {
        console.error(` Error archiving ${queryKey}:`, error);
      },
    });
  const useDelete = () =>
    useMutation({
      mutationFn: async (id) => {
        if (!orgId) throw new Error("Missing org ID");

        return api.delete(`${endpoint}${id}/?org=${orgId}`);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [queryKey, orgId] });
      },
      onError: (error) => {
        console.error(`Error deleting ${queryKey}:`, error);
      },
    });

  return {
    useGetAll,
    useGetById,
    useGetFiltered,
    useCreate,
    useUpdate,
    useArchive,
    useDelete,
    useGetFilteredByDateRange,
  };
};
